import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { CreateEntityConnectionGQL, CreateNoteGQL, CustomFormDetailsFragment, EntityCore } from 'generated/graphql';

import { ApplyTagsService } from 'field-shared/apply-tags.service';
import { ApplyTagFormModel } from 'field-shared/ApplyTagFormModel';
import { isNilOrEmpty } from 'helpers';

import { CustomFormApplier } from './CustomFormApplier';
import { ConnectionFormValue } from 'entity/forms/create-connection-form/create-connection-form.component';

@Injectable({
  providedIn: 'root'
})
export class CustomFormSubmissionService {

  constructor(
    private _applyTagsService: ApplyTagsService,
    private _createNotesGQL: CreateNoteGQL,
    private _createEntityConnectionGQL: CreateEntityConnectionGQL
  ) { }

  createApplierForEntity(
    form: FormGroup,
    customFormSettings: CustomFormDetailsFragment,
    entity: EntityCore.Fragment): CustomFormApplier {
    return new CustomFormApplier(entity, form,
      customFormSettings,
      this._applyTagsService,
      this._createNotesGQL,
      this._createEntityConnectionGQL);
  }

  // TODO: Move to helper class
  static NumberOfItemsToCreate(form: FormGroup, customFormSettings?: CustomFormDetailsFragment): number {
    const tags = this.GetTagsFromForm(form);
    const notes = this.GetNotesFromForm(form);
    return tags.length + notes.length;
  }

  static GetNotesFromForm(form: FormGroup): { text: string }[] {
    const keys = Object.keys(form.controls).filter(key => key.includes('GlobalNote'));
    const notes = keys
      .map(k => form.controls[k].value)
      .filter(v => !isNilOrEmpty(v))
      .map(v => ({ text: v }));

    return notes;
  }

  static GetConnectionsFromForm(form: FormGroup): ConnectionFormValue[] {
    const values = Object.values(form.controls)
      .flatMap(c => c.value)
      .filter(t => t?.selectedEntity);
    return values;
  }

  static GetTagsFromForm(form: FormGroup): ApplyTagFormModel[] {
    return Object.values(form.controls)
      .flatMap(c => c.value)
      .filter(t => t?.selectedTag);
  }

}
